<template>

  <div class="mt-2">
    <div class="row cards">
      <div class="col-md-6">
        <ApiToken/>
      </div>

      <div class="col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            DOCUMENTAÇÃO
          </div>
          <div class="ibox-content">
            <p class="mb-2">
              A documentação traz todos os endpoints com exemplos de requisição e resposta.
            </p>

            <a class="btn btn-outline mr-2" target="_blank" href="/api-docs">
              Ir para documentação
              <external-link-icon class="ml-2" size="1.2x"/>
            </a>

            <button class="btn btn-outline" @click="showModal = !showModal">
              DFe Sync
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <WebhookIndex/>
      </div>
    </div>

    <div class="row" v-if="enabledXmlAuthenticator">
      <div class="col-md-12">
        <Integration/>
      </div>
    </div>

    <Modal v-model="showModal" width="xl">
      <div slot="header">
        <h3>DFe Sync</h3>
      </div>

      <DfeSync/>
    </Modal>

  </div>
</template>

<script>
  import ApiToken from '@/components/definitions/ApiToken'
  import DfeSync from '@/components/definitions/DfeSync'
  import GetAccount from '@/mixins/GetAccount'
  import Integration from '@/components/definitions/Integration'
  import Modal from '@/components/shares/specialTag/Modal'
  import WebhookIndex from '@/components/webhooks/Index'
  import { ExternalLinkIcon } from 'vue-feather-icons'

  export default {
    components: { ApiToken, DfeSync, ExternalLinkIcon, Integration, Modal, WebhookIndex },
    computed: {
      enabledXmlAuthenticator() {
        return this.getAccount?.metadata.xmlAuthenticator
      }
    },
    data: () => ({
      showModal: false
    }),
    mixins: [GetAccount],
    name: 'APIAndIntegration'
  }
</script>

<style scoped lang="scss">

  .cards .ibox {
    height: calc(100% - 8px);
  }

</style>
